var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.6667,
    height: 40.6667,
    rx: 8.33333,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_17675",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.33203,
    y: 8.33301,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_17675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.332 27.333H14.5935L24.83 17.0965L23.5685 15.835L13.332 26.0715V27.333ZM11.832 28.833V25.4485L25.0225 12.2638C25.1737 12.1264 25.3406 12.0203 25.5233 11.9455C25.7061 11.8705 25.8978 11.833 26.0983 11.833C26.2988 11.833 26.4929 11.8686 26.6808 11.9398C26.8688 12.0109 27.0352 12.1241 27.18 12.2793L28.4013 13.5158C28.5564 13.6606 28.667 13.8273 28.733 14.0158C28.799 14.2043 28.832 14.3928 28.832 14.5813C28.832 14.7824 28.7977 14.9743 28.729 15.157C28.6604 15.3398 28.5511 15.5068 28.4013 15.658L15.2165 28.833H11.832ZM24.1883 16.4768L23.5685 15.835L24.83 17.0965L24.1883 16.4768Z",
    fill: "#F46530"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8db32077e76a27348adb551d763e0788.svg";
export { ForwardRef as ReactComponent };